import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import BadgeComponent from '@segment/matcha/components/Badge';
export var Badge = /*#__PURE__*/_styled(BadgeComponent, true ? {
  target: "e1bsms7i0"
} : {
  target: "e1bsms7i0",
  label: "Badge"
})(true ? {
  name: "1r0wq0g",
  styles: "position:absolute;top:8px;right:8px;text-transform:uppercase"
} : {
  name: "1r0wq0g",
  styles: "position:absolute;top:8px;right:8px;text-transform:uppercase",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvSW50ZWdyYXRpb25DYXJkL0JhZGdlL0JhZGdlLnZpZXdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUkyQyIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL0ludGVncmF0aW9uQ2FyZC9CYWRnZS9CYWRnZS52aWV3cy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5pbXBvcnQgQmFkZ2VDb21wb25lbnQgZnJvbSAnQHNlZ21lbnQvbWF0Y2hhL2NvbXBvbmVudHMvQmFkZ2UnXG5cbmV4cG9ydCBjb25zdCBCYWRnZSA9IHN0eWxlZChCYWRnZUNvbXBvbmVudClgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA4cHg7XG4gIHJpZ2h0OiA4cHg7XG4gIHRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7XG5gXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});